import { Types } from '@store/types';

const initialState = { activeTab: 'PENDING', filterField: {} };

const BuyerRequestReducer = (state = initialState, action) => {
	switch (action.type) {
		case Types.SET_BUYER_REQUEST_FILTER_DATA:
			return { ...state, filterField: { ...action.payload } };
		case Types.SET_BUYER_REQUEST_ACTIVE_TAB:
			return { ...state, activeTab: action.payload };
		case Types.CLEAR_BUYER_REQUEST:
			return { ...state, filterField: {} };
		default:
			return state;
	}
};

export default BuyerRequestReducer;
